// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blinking[data-v-700621ee] {\n  -webkit-animation:blink-700621ee 1s ease-in-out infinite alternate;\n  animation:blink-700621ee 1s ease-in-out infinite alternate;\n}\n@-webkit-keyframes blink-700621ee {\n0% { opacity:0\n}\n100% { opacity:1\n}\n}\n@keyframes blink-700621ee {\n0% { opacity:0\n}\n100% { opacity:1\n}\n}\n", ""]);
// Exports
module.exports = exports;
